import Utils from '../utils';


export default class ScrollIndicator {
    constructor() {
        this.scrollIndicator = $('.excuse__scroll-indicator');
    }

    hide() {
        if (this.scrollIndicator.hasClass(Utils.hideClassName()) === false) {
            this.scrollIndicator.addClass(Utils.hideClassName());
        }
    }

    show() {
        this.scrollIndicator.removeClass(Utils.hideClassName());
    }
}



// WEBPACK FOOTER //
// ./frontend/js/modules/scrollindicator.js